// RAM y almacenamiento de un teléfono. El catálogo los manda como número de GB en texto («256»);
// los SKU viejos todavía pueden traer «256 GB». Puro, sin React.

const DIGITS = /^\d+$/;
const AMOUNT = /^(\d+(?:[.,]\d+)?)\s*(gb|tb)?$/i;
const GB_PER_TB = 1024;

/** Cifra y unidad de «256», «256 GB» o «1 TB»; `null` si no es una cantidad. */
function amountOf(value: string | null | undefined): { amount: string; tera: boolean } | null {
    const match = AMOUNT.exec(value?.trim() ?? '');
    if (match === null) return null;
    const unit = match[2] as string | undefined;
    return { amount: match[1], tera: unit?.toLowerCase() === 'tb' };
}

/** Lo mínimo para nombrar la capacidad de una variante. */
export interface CapacityParts {
    ram?: string | null;
    capacity?: string | null;
}

/** «256», «256GB» o «256 gb» → «256 GB»; «1tb» → «1 TB»; otro texto tal cual; sin dato, vacío. */
export function formatStorage(value: string | null | undefined): string {
    const text = value?.trim() ?? '';
    const parsed = amountOf(text);
    if (parsed === null || !DIGITS.test(parsed.amount)) return text;
    return `${parsed.amount} ${parsed.tera ? 'TB' : 'GB'}`;
}

/** Los GB del valor («256», «256 GB», «1 TB»); `null` si no trae cifra. */
export function capacityGb(value: string | null | undefined): number | null {
    const parsed = amountOf(value);
    if (parsed === null) return null;
    const amount = Number(parsed.amount.replace(',', '.'));
    return parsed.tera ? amount * GB_PER_TB : amount;
}

/** «8 GB RAM»; sin dato, vacío. */
export function ramLabel(value: string | null | undefined): string {
    const ram = formatStorage(value);
    return ram === '' ? '' : `${ram} RAM`;
}

/** «8 GB RAM · 256 GB» con RAM; «256 GB» sin ella. */
export function variantCapacityLabel(item: CapacityParts): string {
    return [ramLabel(item.ram), formatStorage(item.capacity)]
        .filter((part) => part !== '')
        .join(' · ');
}

/** «8 GB RAM · 256 GB · Negro»: la ficha que distingue dos variantes del mismo modelo. */
export function variantLabel(item: CapacityParts & { color?: string | null }): string {
    return [variantCapacityLabel(item), item.color?.trim() ?? '']
        .filter((part) => part !== '')
        .join(' · ');
}
